export default "__VITE_ASSET__3eb11d71__"